import React from 'react';

import { connect } from "react-redux";
import { changeFilter, changeDatalist, changeMutex, changeValues } from "../../redux/actions";
import { imgTavolaSelector } from "../../redux/selectors";

import BaseClass from '../common/baseClass';
import Zoomist from 'zoomist'

const common = require('../common/common');
const env = require("../../config.js").default;

class ImgTavola extends BaseClass {
  constructor(props) {
    super(props);
    this.zoomistInstance = null;
    this.tavolaDescription = null;
  }

  componentWillMount(props){
    this.updateStateWithStoreProps();

    if(this.state.renewMutex.immagineTavola && this.state.filtersState.marca && this.state.filtersState.modello && this.state.filtersState.tavola){
      this.props.changeMutex("immagineTavola", false);
      this.getImgData();
    }
  }

  componentDidMount(){
    const $ = window.$;
    if(this.state.renewMutex.mostraImg){
      $('.gruppo_varianti.prima .fas').on('click', (e) => {
        if(!$('.gruppo_varianti').hasClass("mostra_varianti")){
          $('.' + e.currentTarget.classList[1]).each(function() {
            $(this).toggleClass("mostra_varianti");
          });
        }else{
          $('.' + e.currentTarget.classList[1]).each(function() {
            $(this).toggleClass("mostra_varianti");
          });
        }
      });
    }
  }

  componentWillReceiveProps(nextprops){
    this.updateStateWithStoreProps(nextprops);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.store.filtersState.tavola !== this.state.filtersState.tavola) {
      this.props.changeMutex("immagineTavola", false);
      this.getImgData();
    }

    if (Object.keys(this.state.dataList.tavole).length > 0) {
      let found = false;
      for (let group of Object.keys(this.state.dataList.tavole)) {
        for (let tav of this.state.dataList.tavole[group]) {
          if (tav['CTAVO'] === this.state.filtersState.tavola) {
            found = true;
            this.tavolaDescription = tav['DTAVO'];
            break;
          }
        }
        if (found === true)
          break;
      }
    }

  }

  getImgData = () => {
    const $ = window.$;
    if (this.state.filtersState.marca && this.state.filtersState.modello && this.state.filtersState.tavola && this.state.filtersState.immagine) {
      var data = { zprod: this.state.filtersState.marca, cmoto: this.state.filtersState.modello, ctavo: this.state.filtersState.tavola, cdima: this.state.filtersState.immagine };
      common.apiCall(env.BACKEND + "epc/get_draw_image/", "GET", data, true, false, 'json', env.RECAPTCHA_VERIFY)
        .then((immagineTavola) => {
          if (immagineTavola.error === false) {
            this.props.changeValues({ renewMutex: { mostraImg: true }, dataList: { immagineTavola: immagineTavola } });
          } else
            $(".banner_center_header>a").click();
          return
        });
    }
  }

  initZoomInstance(img) {
    const $ = window.$;
    if(img !== undefined && img !== null){
      window.$(document).ready(() => {
        if (!this.state.renewMutex.immagineTavola) {
          $("#immagineTavolaContainer").height(window.$("#distintaTableContainer").css("max-height"));
          if (this.zoomistInstance !== null)
            this.zoomistInstance.destroy(true)
          this.zoomistInstance = new Zoomist("#immagineTavolaContainer", {
            maxScale: 7,
            zoomer: {
              resetEl: ".resetButtonImg"
            }
          });
        }
      });
    }
  }

  render() {
    return (
      <div className="col-xl-6 col-12">
        <div className="col-12 zoomist-container" id="immagineTavolaContainer">
          {!this.state.renewMutex.immagineTavola ?
            <>
              <button className='resetButtonImg' aria-label="Reset zoom">
                <i className="fas fa-redo-alt"></i>
              </button>
              <div className="zoomist-wrapper">
                <div className="zoomist-image">
                  <img src={this.state.dataList.immagineTavola.img} id="immagineTavola" alt={this.tavolaDescription ?? ''}></img>
                </div>
              </div>
              {this.initZoomInstance(this.state.dataList.immagineTavola.img)}
            </>
          :
            ""
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const store = imgTavolaSelector(state);
  return { store };
}
export default connect(mapStateToProps, {changeFilter, changeDatalist, changeMutex, changeValues})(ImgTavola);
